export default "__VITE_ASSET__tu2TsMF0__"